/**
 * Rep Landing Page — variant selection + add to cart
 * Uses Shopify's native /cart/add.js endpoint (native cart, no custom cart).
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initCard(card) {
    var variantsScript = card.querySelector('[data-rep-variants]');
    if (!variantsScript) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }

    var selects = Array.prototype.slice.call(card.querySelectorAll('[data-rep-option-index]'));
    var variantIdInput = card.querySelector('[data-rep-variant-id]');
    var priceEl = card.querySelector('[data-rep-price]');
    var submitBtn = card.querySelector('[data-rep-submit]');
    var btnText = card.querySelector('[data-rep-btn-text]');
    var form = card.querySelector('[data-rep-add-to-cart]');
    var viewCartLink = card.querySelector('[data-rep-view-cart]');

    function currentSelection() {
      // Ordered array of selected option values, matches Shopify's option1/2/3 order
      var selection = [];
      selects.forEach(function (select) {
        var index = parseInt(select.getAttribute('data-rep-option-index'), 10);
        selection[index] = select.value;
      });
      return selection;
    }

    function findMatchingVariant() {
      var selection = currentSelection();
      return variants.find(function (variant) {
        var options = [variant.option1, variant.option2, variant.option3];
        return selection.every(function (value, i) {
          return value === undefined || options[i] === value;
        });
      });
    }

    function updateForVariant(variant) {
      if (!variant) {
        submitBtn.setAttribute('disabled', 'disabled');
        btnText.textContent = 'Unavailable';
        return;
      }

      variantIdInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (variant.available) {
        submitBtn.removeAttribute('disabled');
        btnText.textContent = 'Add to Cart';
      } else {
        submitBtn.setAttribute('disabled', 'disabled');
        btnText.textContent = 'Sold Out';
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        updateForVariant(findMatchingVariant());
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        if (submitBtn.hasAttribute('disabled')) return;

        var originalText = btnText.textContent;
        submitBtn.setAttribute('disabled', 'disabled');
        btnText.textContent = 'Adding...';

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            btnText.textContent = 'Added ✓';
            submitBtn.removeAttribute('disabled');
            if (viewCartLink) viewCartLink.hidden = false;

            // Best-effort: refresh common theme cart bubble / drawer if present.
            // Safe no-ops if the theme doesn't use these hooks.
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated'));

            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var bubbles = document.querySelectorAll(
                  '.cart-count-bubble, #cart-icon-bubble, [data-cart-count]'
                );
                bubbles.forEach(function (el) {
                  el.textContent = cart.item_count;
                });
              })
              .catch(function () {});

            setTimeout(function () {
              btnText.textContent = originalText;
            }, 2000);
          })
          .catch(function () {
            btnText.textContent = 'Try Again';
            submitBtn.removeAttribute('disabled');
          });
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-rep-product-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();